export default __webpack_public_path__ + "11b08e7844414dc2d2625dd481d95464.webp";